"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dompurify_html_1 = require("./dompurify-html");
exports.default = {
    install: function (Vue, config) {
        if (config === void 0) { config = {}; }
        Vue.directive('dompurify-html', dompurify_html_1.buildDirective(config));
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/vue-dompurify-html/dist/index.js
// module id = 1033
// module chunks = 13